// extracted by mini-css-extract-plugin
export default {"root":"U1O3D","item":"alWTI"};